import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { I18nProvider } from "@/context/I18nContext";
import Navbar from "@/components/Navbar";
import MiniPlayer from "@/components/MiniPlayer";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import Seo from "@/components/Seo";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import MyMusic from "@/pages/MyMusic";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid min-h-screen place-items-center text-zinc-500">Se incarca...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !["admin", "superadmin"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function Shell() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <ScrollToTop />
      <Seo />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/music" element={<MyMusic />} />
          <Route path="/catalog" element={<Navigate to="/music" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/legal/:type" element={<Legal />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/my-music" element={<Navigate to="/music" replace />} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <PWAInstallPrompt />
      <MiniPlayer />
      <Toaster
        position="top-right" theme="dark"
        toastOptions={{ style: { background: "#121212", border: "1px solid rgba(255,255,255,0.08)", color: "#fff" } }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <PlayerProvider>
            <Shell />
          </PlayerProvider>
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
